import React, { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useFeatureFlagContext } from '../../contexts/FeatureFlagContext'
import { FEATURE_FLAG_KEYS_ENUM } from '../../models/feature_flags.types'
import { useUserContext } from '../../contexts/UserContext'
import { useDispatch } from 'react-redux'
import { setUserOverride } from '../../redux/userSlice'
import RoutingPage from './RoutingPage'
import { Box, Link } from '@chakra-ui/react'
import { useReduxSelector } from '../../redux/baseStore'
import { useNavigate } from 'react-router-dom'

const getVersionOverrideParamValue = (searchParams: URLSearchParams) => {
  const versionOverrideParam = searchParams.get('__version')
  return versionOverrideParam === 'v5'
    ? 'v5'
    : versionOverrideParam === 'v4'
      ? 'v4'
      : versionOverrideParam === 'v3'
        ? 'v3'
        : null
}

const MainPage: FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { captureAnalytics } = useUserContext()
  const { featureFlags } = useFeatureFlagContext()
  const isAlpha = featureFlags[FEATURE_FLAG_KEYS_ENUM.IsAlphaUser]
  const userOverride = useReduxSelector((state) => state.user.userOverride)
  const [searchParams] = useSearchParams()
  const versionOverride = getVersionOverrideParamValue(searchParams)
  const ffMorningPageType = isAlpha ? 'v5' : 'v4'
  const morningPageType = versionOverride || ffMorningPageType

  const userOverrideParam = searchParams.get('__user_override')

  useEffect(() => {
    if (userOverrideParam) {
      dispatch(setUserOverride(userOverrideParam))
    }
  }, [userOverrideParam, dispatch])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!window.document.hidden) {
        captureAnalytics('mainpage:view')
      }
    }
    window.document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      window.document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [captureAnalytics])

  return (
    <>
      {/* User Override Warning Banner */}
      {userOverride && (
        <Box
          position="fixed"
          bottom={0}
          left={0}
          right={0}
          bg="red.500"
          color="white"
          p={4}
          zIndex={9999}
          textAlign="center"
          fontWeight="bold"
          fontSize="lg"
        >
          YOU ARE VIEWING THE APP AS {userOverride.toUpperCase()}
          <Link
            color="white"
            textDecoration="underline"
            ml={4}
            onClick={() => navigate('/admin')}
            cursor="pointer"
          >
            Back to admin
          </Link>
        </Box>
      )}

      <Box
        display="flex"
        flexDirection="column"
        height="100vh"
        width="100vw"
        pb={userOverride ? '80px' : '0'}
      >
        <RoutingPage morningPageType={morningPageType} />
      </Box>
    </>
  )
}

export default MainPage
